import { render, staticRenderFns } from "./EnableTradingSetting.vue?vue&type=template&id=66279357&scoped=true"
import script from "./EnableTradingSetting.vue?vue&type=script&lang=js"
export * from "./EnableTradingSetting.vue?vue&type=script&lang=js"
import style0 from "./EnableTradingSetting.vue?vue&type=style&index=0&id=66279357&prod&lang=scss&scoped=true"
import style1 from "./EnableTradingSetting.vue?vue&type=style&index=1&id=66279357&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66279357",
  null
  
)

export default component.exports